import { alpha } from "@mui/material/styles";
import { green, red, yellow } from "@mui/material/colors";

export type ShotType = "rim" | "nonRimTwo" | "pullUpThree" | "csThree";

const THRESHOLDS: Record<ShotType, { low: number; high: number }> = {
  csThree: { low: 35, high: 45 },
  pullUpThree: { low: 35, high: 45 },
  nonRimTwo: { low: 45, high: 55 },
  rim: { low: 55, high: 65 },
};

export const getFgPctColor = (fgPct: number, totalAtt: number, shotType: ShotType): string => {
  if (totalAtt < 2) return "transparent";
  const { low, high } = THRESHOLDS[shotType];
  if (fgPct > high) return alpha(green[500], 0.2);
  if (fgPct < low) return alpha(red[500], 0.2);
  return alpha(yellow[700], 0.2);
};
